/**
 * Ability Slice - Handles ability/seal-related state changes
 *
 * Actions handled:
 * - SET_SHIELD_USES
 * - SET_PEEK_USES
 * - SET_PEEKED_CARD
 * - SET_SEAL_RING_USES
 * - SET_MAGNET_USES
 * - SET_SWAP_USES
 * - SET_GLUECKSGRIFF_USES
 */

// Initial ability state (extracted from initialGameState)
export const initialAbilityState = {
  shieldUses: [],
  peekUses: [],
  sealRingUses: [],
  magnetUses: [],
  swapUses: [],
  gluecksgriffUses: [],
  middleFingerActive: false,
  peekedCard: null,
  peekedCards: [],
  // Timestamp until which Sneak Peak peekedCard is protected from gameStateUpdate overwrites
  activePeekUntil: 0,
};

/**
 * Ability action types
 */
export const ABILITY_ACTIONS = [
  'SET_SHIELD_USES',
  'SET_PEEK_USES',
  'SET_PEEKED_CARD',
  'SET_SEAL_RING_USES',
  'SET_MAGNET_USES',
  'SET_SWAP_USES',
  'SET_GLUECKSGRIFF_USES',
];

/**
 * Check if action is handled by this slice
 */
export function isAbilityAction(actionType) {
  return ABILITY_ACTIONS.includes(actionType);
}

/**
 * Ability reducer slice
 */
export function abilityReducer(state, action) {
  switch (action.type) {
    case 'SET_SHIELD_USES':
      return {
        ...state,
        shieldUses: action.payload,
      };

    case 'SET_PEEK_USES':
      return {
        ...state,
        peekUses: action.payload,
      };

    case 'SET_PEEKED_CARD':
      return {
        ...state,
        peekedCard: action.payload,
        // Protect Sneak Peak peekedCard from gameStateUpdate for 3.5 seconds
        // (slightly longer than the 3s display timeout to handle network delays)
        activePeekUntil: action.payload ? Date.now() + 3500 : 0,
      };

    case 'SET_SEAL_RING_USES':
      return {
        ...state,
        sealRingUses: action.payload,
      };

    case 'SET_MAGNET_USES':
      return {
        ...state,
        magnetUses: action.payload,
      };

    case 'SET_SWAP_USES':
      return {
        ...state,
        swapUses: action.payload,
      };

    case 'SET_GLUECKSGRIFF_USES':
      return {
        ...state,
        gluecksgriffUses: action.payload,
      };

    default:
      return state;
  }
}

export default abilityReducer;
